/** Tolerância alinhada à capa visual de saldo da conciliação. */
export const TOL_DIVERGENCIA_CAPA = 0.02;

/**
 * Indica se a diferença numérica da capa está dentro da tolerância.
 * `null`/inválido → false (saldo incompleto quando a capa tem saldos).
 */
export function saldoCapaFechado(diferenca) {
  if (diferenca === null || diferenca === undefined) {
    return false;
  }
  const n = Number(diferenca);
  if (!Number.isFinite(n)) {
    return false;
  }
  return Math.abs(n) <= TOL_DIVERGENCIA_CAPA;
}

/**
 * Libera exportação Domínio/Protheus conforme a capa de saldo.
 *
 * - Sem dados de capa ainda: bloqueia.
 * - Sem `saldoAnterior` e sem `saldoAtual` (legado / OFX): libera (grandfathering).
 * - Com saldos: exige `|diferenca| ≤ 0,02`.
 * - Com saldo parcial (só um lado) e diferença incalculável: bloqueia.
 */
export function exportacaoSaldoLiberada(capaSaldo) {
  if (capaSaldo == null || typeof capaSaldo !== "object") {
    return false;
  }
  if (capaSaldo.saldoAnterior == null && capaSaldo.saldoAtual == null) {
    return true;
  }
  return saldoCapaFechado(capaSaldo.diferenca);
}
